export const MAX_ACTIVE_SPRINTS = 5;
export const MAX_RESULTS = 10;
